import {StateService, UrlService, StateOrName, RawParams} from '@uirouter/angular';
import {Injectable} from '@angular/core';
import {STATE_NAMES} from '../common/state-names';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class RoutingService {
  private message = new BehaviorSubject([]);
  sharedTitle = this.message.asObservable();

  constructor(private stateService: StateService, private urlService: UrlService) {

  }

  get params(): RawParams {
    return this.stateService.params;
  }

  go(to: StateOrName, rawParams?: RawParams, reload = false) {
    this.stateService.go(to, rawParams, {'reload': reload});
  }

  pageTitle(title: any, clientName?: string) {
    let data;
    if (clientName) {
      data = [{
        name: title[0].name,
        link: true,
        url: title[0].url,
      }];
      data.push({
        name: clientName
      });
    } else {
      data = title;
    }
    this.message.next(data);
  }

  goToLoginPage() {
    if (this.stateService.current.name !== STATE_NAMES.login) {
      this.stateService.go(STATE_NAMES.login);
    }
  }

  queryString(key: string): string {
    return this.urlService.parts().search[key];
  }
}
